import {HeroCardAlt} from "./HeroCardAlt.jsx";
import {HeaderTitle} from "./HeaderTitle.jsx";
import PropTypes from "prop-types";


export const HomeSection = ({items, title}) => {


    return (
        <>
            <HeaderTitle size={'h3'} title={title}/>
            <div className={'d-flex mb-5 gap-3'}>
                {items.map((item, index) => {
                        return (
                            <div key={index} className={'d-flex gap-2'}>
                                <HeroCardAlt key={index} {...item}/>
                            </div>
                        )

                    }
                )}
            </div>

        </>
    )
}

HomeSection.propTypes = {
    title: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({
        icon: PropTypes.node.isRequired,
        text: PropTypes.string.isRequired,
        actionLink: PropTypes.string.isRequired,
        actionText: PropTypes.string.isRequired,
    })).isRequired
};